import WindowMetrics from '../utilities/window-metrics';

const settings = {
    classNames: {
        container: 'responsive-video',
        desktop: 'desktop-only',
        mobile: 'mobile-only',
    },

    excludeAttributes: [
        'class',
        'data-responsive-video-mobile-src',
        'data-responsive-video-desktop-src',
    ],
};

const createVideoCallbacks = [];

export default class ResponsiveVideoLoader {
    constructor(container) {
        this.video = {
            mobile: null,
            desktop: null,
        };

        const mobileSrc = container.getAttribute('data-responsive-video-mobile-src');
        const desktopSrc = container.getAttribute('data-responsive-video-desktop-src');
        if (!mobileSrc || !desktopSrc) {
            throw new Error();
        }

        // Copy any attributes from our container placeholder
        // EDIT: some of this doesn't work, so just hardcoding the video
        // settings for now
        // const videoAttributes = {};
        // for (let i=0; i<container.attributes.length; i++) {
        //     const attribute = container.attributes[i];
        //     if (settings.excludeAttributes.includes(attribute.name)) {
        //         continue;
        //     }

        //     videoAttributes[attribute.name] = attribute.value;
        // }

        const autoplay = container.hasAttribute('autoplay');

        const createVideoElement = (src, className, neighboringVideo) => {
            // Create video element
            const video = document.createElement('video');
            video.className = className;
            video.tabIndex = -1;

            // // Apply any attributes picked up by our container placeholder
            // for (const name in videoAttributes) {
            //     if (videoAttributes.hasOwnProperty(name)) {
            //         video.setAttribute(
            //             name,
            //             videoAttributes[name],
            //         );
            //     }
            // }

            // EDIT: hardcoded settings
            if (autoplay) {
                video.autoplay = true;
            }
            video.muted = true;
            video.disablePictureInPicture = true;
            video.loop = true;
            video.playsInline = true;

            // Create source element
            const source = document.createElement('source');
            source.src = src;
            source.type = 'video/mp4';
            video.appendChild(source);

            // Add the new video element to the DOM
            if (container) {
                // Replace the container with the new video element
                container
                    .parentNode
                    .insertBefore(video, container);

                container.parentNode.removeChild(container);
                container = null;
            } else {
                // Insert the new video element beside a previously
                // created video for a different breakpoint
                neighboringVideo
                    .parentNode
                    .insertBefore(video, neighboringVideo);
            }

            // Perform any registered callbacks
            createVideoCallbacks.forEach((callback) => {
                callback(video);
            });

            return video;
        };

        const breakpointChangeCallback = function(mobileDesktopTransition) {
            if (!mobileDesktopTransition) {
                return;
            }

            if (WindowMetrics.isMobile()) {
                // Stop playing videos for other breakpoints
                if (this.video.desktop) {
                    this.video.desktop.pause();
                }

                // Check if we've already initialized
                if (this.video.mobile && autoplay) {
                    this.video.mobile.play();
                    return;
                }

                this.video.mobile = createVideoElement(
                    mobileSrc,
                    settings.classNames.mobile,
                    this.video.desktop,
                );

                if (autoplay) {
                    this.video.mobile.play();
                }
            } else {
                // Stop playing videos for other breakpoints
                if (this.video.mobile) {
                    this.video.mobile.pause();
                }

                // Check if we've already initialized
                if (this.video.desktop && autoplay) {
                    this.video.desktop.play();
                    return;
                }

                this.video.desktop = createVideoElement(
                    desktopSrc,
                    settings.classNames.desktop,
                    this.video.mobile,
                );

                if (autoplay) {
                    this.video.desktop.play();
                }
            }
        }.bind(this);

        WindowMetrics
            .addBeakpointChangeCallback(breakpointChangeCallback);

        // Initialize the video corresponding to the current breakpoint
        breakpointChangeCallback(true);
    }

    static init() {
        // Find elements with the expected class name
        const elements = document
            .getElementsByClassName(settings.classNames.container);

        for (let i=0; i<elements.length; i++) {
            new ResponsiveVideoLoader(elements[i]);
        }
    }

    static addCreateVideoCallback(callback) {
        createVideoCallbacks.push(callback);
    }
}
